import React, { createContext, useState, useContext } from 'react';
import apiService from '../services/apiService';

const transformWorkLogs = (items) => {
  if (!Array.isArray(items)) return [];
  return items.map((item) => {
    const { _id, ...rest } = item;
    return { id: _id, ...rest };
  });
};

const transformWorkLog = (pro) => {
  const { _id, members = [], ...rest } = pro;
  return { id: _id, members, ...rest };
};

// Create the context
const WorkLogContext = createContext();

// Create a custom hook for easier access
export const useWorkLog = () => {
  return useContext(WorkLogContext);
};

// Export the provider to wrap around the app
export const WorkLogProvider = ({ children }) => {
  const [workLogs, setWorkLogs] = useState([]);
  const [workLogsByProject, setWorkLogsByProject] = useState([]);
  const [currentQuery, setCurrentQuery] = useState({});

  // Function to add a new work log
  const addWorkLog = async (payload) => {
    await apiService.post('/api/v1/work-log', payload);
    fetchWorkLogs(currentQuery);
  };

  // Function to update a work log
  const updateWorkLog = async ({ workLogId, ...payload }) => {
    const res = await apiService.patch(
      `/api/v1/work-log/${workLogId}`,
      payload
    );
    setWorkLogs((prevWL) =>
      prevWL.map((item) => {
        if (item.id === workLogId) {
          return transformWorkLog(res);
        }
        return item;
      })
    );
  };

  // Function to remove a work log by id
  const removeWorkLog = async (id) => {
    await apiService.delete(`/api/v1/work-log/${id}`);
    setWorkLogs((prevWL) => prevWL.filter((item) => item.id !== id));
  };

  // Function to fetch projects (could be from an API)
  const fetchWorkLogs = async (params) => {
    setCurrentQuery(params);
    const { data } = await apiService.get('/api/v1/work-log', { params });
    setWorkLogs(transformWorkLogs(data || []));
  };

  const fetchWorkLogByProject = async (params) => {
    const { data } = await apiService.get('/api/v1/work-log/get-by-project', {
      params,
    });
    setWorkLogsByProject(transformWorkLogs(data || []));
  };

  return (
    <WorkLogContext.Provider
      value={{
        workLogs,
        workLogsByProject,
        addWorkLog,
        removeWorkLog,
        updateWorkLog,
        fetchWorkLogs,
        fetchWorkLogByProject,
      }}>
      {children}
    </WorkLogContext.Provider>
  );
};
